const replaceItemInRecursiveArray = (arrayToReplace, itemToReplace, result, subItemsKey) => {
  if (!arrayToReplace) {
    return arrayToReplace;
  }

  const indexOfItemToReplace = arrayToReplace.indexOf(itemToReplace);

  if (indexOfItemToReplace >= 0) {
    arrayToReplace.splice(indexOfItemToReplace, 1, result);

    return arrayToReplace;
  }

  arrayToReplace.forEach(item => {
    item[subItemsKey] = replaceItemInRecursiveArray(item[subItemsKey], itemToReplace, result, subItemsKey);
  });

  return arrayToReplace;
};

export default replaceItemInRecursiveArray;
